<div class="modal-header">
    <button class="btn btn-success" (click)="downloadISOdata();">
        <span *ngIf="!buttonLoader" class="feather icon-download mr-1"></span>
        <span *ngIf="buttonLoader" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        Download
    </button>
    <h5 *ngIf="showDiv==false" class="modal-title font-weight-bold mt-2" id="modal-basic-title">[ Sales Person : {{spName}} ] Customer wise TPN added count</h5>
    <h5 *ngIf="showDiv==true" class="modal-title font-weight-bold mt-2" id="modal-basic-title">Salesperson wise customers list</h5> 
    
    <button type="button" class="close mt-2" aria-label="Close" (click)="modal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="card-body logs" *ngIf="showDiv == false">
    <div class="pb-md-3 table-responsive">
      <!-- {{recurringPaymentTxData | json}} -->
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th class="pt-0 header_bolder text-left popup-headers" width="30%">Customers (DBA Name)</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="15%">Today*</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="15%">This Month*</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="15%">Last Month*</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="15%">Overall*</th>
            <!-- <th class="pt-0 header_bolder text-left popup-headers" width="20%">Created On</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Deactivated On</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Last Transaction Date</th> -->
          </tr>
        </thead>                     
        <tbody>

          <tr *ngFor="let customers of customerWiseTpnList">
            <!-- <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.createdBy || 'NA'}}</span>
            </td> -->
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{customers.dba || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{customers.Today}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{customers.TM}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{customers.LM}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(customers.Total)}}</span>
            </td>
            <!-- <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.createdOn | dateTimePipe) || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
                <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.deactivatedOn | dateTimePipe) || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
                <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.lastTxDate | dateTimePipe) || 'NA'}}</span>
            </td> -->
          </tr>
        </tbody>
      </table>
      <br>Note: *Above TPN count includes the TPN's which are deactivated too
    </div>
</div>

<div class="card-body logs" *ngIf="showDiv == true">
  
  <div class="shadow p-2 mb-4 bg-white rounded">
    <div class="row">
      <!-- Customer Name Filter -->
      <div class="col-md-3">
        <ng-select [items]="customerDbaList" bindLabel="dba" placeholder="Filter by Customers (DBA Name)"
          [(ngModel)]="selectedCustomer" (change)="filterCustomers()" [clearable]="true">
        </ng-select>
      </div>
      
      <!-- CreatedOn Filter -->
      <div class="col-md-2" *ngIf = "timePeriod == 'overall'">
        <ng-select 
          [items]="selectDate" 
          placeholder="Created On"
          [(ngModel)]="selectedDateFilter" 
          (change)="filterCustomers()" 
          [clearable]="true">
        </ng-select>
      </div>      

      <!-- Salesperson Name Filter -->
      <div class="col-md-3">
        <ng-select [items]="customersalesList" bindLabel="firstName" placeholder="Filter by Salesperson"
          [(ngModel)]="salesperson" (change)="filterCustomers()" [clearable]="true">
        </ng-select>
      </div>
   
      <!-- TPN Count Range Inputs -->
      <div class="col-md-4 d-flex">
        <input type="number" class="form-control mx-3" [(ngModel)]="minTPN" (input)="filterCustomers()"
          placeholder="#Min TPN Count" [attr.pattern]="'[0-9]*'"
          inputmode="numeric"
          oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 8)" />
        <input type="number" class="form-control" [(ngModel)]="maxTPN" (input)="filterCustomers()"
          placeholder="#Max TPN Count" [attr.pattern]="'[0-9]*'"
          inputmode="numeric"
          oninput="this.value = this.value.replace(/[^0-9]/g, '').slice(0, 8)" />
      </div>
    </div>
  </div>
 
  <div class="pb-md-3 table-responsive">
    <!-- {{recurringPaymentTxData | json}} -->
    <table class="table table-hover mb-0">
      <thead>
        <tr>
          <th class="pt-0 header_bolder text-left popup-headers" width="30%">Customers (DBA Name)</th>  
          <th class="pt-0 header_bolder text-left popup-headers" width="30%">Created On</th>          
          <th class="pt-0 header_bolder text-left popup-headers" width="25%">Salesperson Name</th>
          <th class="pt-0 header_bolder text-left popup-headers" width="15%">City</th>
          <th class="pt-0 header_bolder text-left popup-headers" width="15%">State</th>
          <th class="pt-0 header_bolder text-left popup-headers" width="15%">TPN Count</th>
        </tr>
      </thead>                     
      <tbody>

        <tr *ngFor="let customers of filteredCustomers">
          <td class="text-left wht_space">
            <span placement="right" triggers="mouseenter:mouseleave" title="{{customers.dba}}">{{customers.dba | slice:0:25}}</span>
          </td>
          <td class="text-left wht_space">
            <span placement="right" triggers="mouseenter:mouseleave">{{(customers.__time || 'N/A') || 'N/A'}}</span>
          </td>
          <td class="text-left wht_space">
            <span placement="right" triggers="mouseenter:mouseleave">{{customers.firstName || 'N/A'}}</span>
          </td>
          <td class="text-left wht_space">
            <span placement="right" triggers="mouseenter:mouseleave">{{customers.city || 'N/A'}}</span>
          </td>
          <td class="text-left wht_space">
            <span placement="right" triggers="mouseenter:mouseleave">{{customers.state || 'N/A'}}</span>
          </td>
          <td class="text-left wht_space">
            <span placement="right" triggers="mouseenter:mouseleave">{{customers.tpn || '0'}}</span>
          </td>
        </tr>
      </tbody>
    </table>    
    <br> <p *ngIf = "filteredCustomers.length > 0">Note: *Above TPN count includes the TPN's which are deactivated too</p>
    <div class="text-center text-danger" *ngIf="maxTPN <= minTPN && maxTPN !== null" >Max TPN count must be greater than Min TPN count!</div>
    <br> <p *ngIf="maxTPN <= minTPN && maxTPN !== null || filteredCustomers.length == 0" class="fs-6 text-center"> No data found</p>
  </div>
</div>